import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ 100h/anno a pianificare da zero',
  with: '✅ 10 min/settimana. Tutto pronto.'
}, {
  without: '❌ Esercizi improvvisati senza progressione',
  with: '✅ 101 esercizi + 6 volumi per livello'
}, {
  without: '❌ Giocatori che migliorano lentamente',
  with: '✅ Progressione logica e misurabile'
}, {
  without: '❌ Famiglie che chiedono risultati',
  with: '✅ Schede di valutazione e dashboard progressi'
}];
const offer = {
  emoji: '🏆',
  title: 'BASKET PRONTO + KIT TATTICO PRO',
  description: '6 Volumi + 6 Bonus + Kit Tattico Pro',
  originalPrice: '€67',
  price: '€19,90',
  ctaText: '🏀 VOGLIO BASKET PRONTO ORA',
  ctaHref: 'https://basket-pronto.impultienda.ar/checkout',
  savings: 'RISPARMI €47'
};
export function FinalCTA() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-54">
      <div className="max-w-2xl mx-auto" data-id="element-55">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white text-center mb-8 tracking-tight leading-tight" data-id="element-56">
          Il prossimo allenamento puoi continuare a improvvisare.{' '}
          <br className="hidden md:block" data-id="element-57" />
          <span className="text-[#FF6B00]" data-id="element-58">
            Oppure puoi entrare in palestra con tutto già pronto.
          </span>
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-white font-bold text-sm sm:text-base mb-12 uppercase tracking-wider" data-id="element-59">
          <span data-id="element-60">Allenamenti.</span>
          <span className="text-[#333]" data-id="element-61">/</span>
          <span data-id="element-62">Esercizi.</span>
          <span className="text-[#333]" data-id="element-63">/</span>
          <span data-id="element-64">Progressioni.</span>
          <span className="text-[#333]" data-id="element-65">/</span>
          <span data-id="element-66">Gestione.</span>
          <span className="text-[#333]" data-id="element-67">/</span>
          <span className="text-[#00C853]" data-id="element-68">Tutto organizzato.</span>
        </div>

        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl overflow-hidden mb-12 shadow-2xl" data-id="element-69">
          <div className="grid grid-cols-2 bg-[#0A0A0A] border-b border-[#FF6B0033]" data-id="element-70">
            <div className="px-4 py-4 font-black text-[#B0B0C0] text-xs sm:text-sm text-center uppercase tracking-wider" data-id="element-71">
              Senza Basket Pronto
            </div>
            <div className="px-4 py-4 font-black text-[#FF6B00] text-xs sm:text-sm text-center border-l border-[#FF6B0033] uppercase tracking-wider" data-id="element-72">
              Con Basket Pronto
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#FF6B0033]' : ''}`} data-id="element-73">
              <div className="px-4 py-4 text-[#B0B0C0] text-xs sm:text-sm font-medium" data-id="element-74">
                {row.without}
              </div>
              <div className="px-4 py-4 text-white font-bold text-xs sm:text-sm bg-[#FF6B00]/5 border-l border-[#FF6B0033]" data-id="element-75">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-76">
          <CountdownTimer size="md" blinking={true} data-id="element-77" />
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-78">
          <div className="relative bg-[#16161F] border-2 border-[#FF6B00] rounded-2xl p-6 shadow-[0_0_40px_rgba(255,107,0,0.15)] overflow-hidden" data-id="element-79">
            <div className="absolute top-0 right-0 bg-[#FF6B00] text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-80">
              🏆 PACCHETTO COMPLETO
            </div>

            <div className="flex items-center gap-2 mb-2 mt-3 sm:mt-0" data-id="element-81">
              <span className="text-xl" data-id="element-82">{offer.emoji}</span>
              <span className="text-white font-black text-base sm:text-lg tracking-tight" data-id="element-83">
                {offer.title}
              </span>
            </div>
            <p className="text-[#B0B0C0] text-sm font-medium mb-5" data-id="element-84">
              {offer.description}
            </p>

            <div className="flex items-end justify-between" data-id="element-85">
              <div data-id="element-86">
                <div className="text-[#B0B0C0] line-through text-sm font-bold mb-1" data-id="element-87">
                  {offer.originalPrice}
                </div>
                <div className="font-black text-4xl sm:text-5xl text-white tracking-tighter leading-none" data-id="element-88">
                  {'\u20AC19'}
                </div>
              </div>
              <span className="inline-block bg-[#00C853]/15 text-[#00C853] text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-89">
                {offer.savings}
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-90">
          <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-2xl py-6 rounded-2xl transition-colors shadow-2xl mb-6" data-id="element-91">
            {offer.ctaText}
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#B0B0C0] font-bold" data-id="element-92">
            <span className="flex items-center gap-1.5" data-id="element-93">
              🔒 Pagamento Sicuro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-94">
              ⚡ Accesso Immediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-95">
              🛡️ Garanzia 7 Giorni
            </span>
            <span className="flex items-center gap-1.5" data-id="element-96">💳 Carta · PayPal</span>
          </div>
        </div>
      </div>
    </section>;
}